import { isArray } from 'lodash';

import { airportServices } from './airportServices';
import { actionTimeControl } from './actionTimeControl';
import { endInfoPage } from './endInfoPage';
import { errors } from './errors';
import { filters } from './filters';
import { flightInfoPage } from './flightInfoPage';
import { flightPage } from './flightPage';
import { flightTaskPage } from './flightTaskPage';
import { global } from './global';
import { loginPage } from './loginPage';
import { messages } from './messages';
import { messenger } from './messenger';
import { modal } from './modal';
import { navigationRoute } from './navigationRoute';
import { notices } from './notices';
import { passengerPage } from './passengerPage';
import { reports } from './reports';
import { sendedData } from './sendedData';
import { summaryTaskPage } from './summaryTaskPage';
import { tasks } from './tasks';
import { whatsNew } from './whatsNew';

const translations = {
    airportServices,
    actionTimeControl,
    endInfoPage,
    errors,
    filters,
    flightInfoPage,
    flightPage,
    flightTaskPage,
    ...global,
    loginPage,
    messages,
    messenger,
    modal,
    navigationRoute,
    notices,
    passengerPage,
    reports,
    sendedData,
    summaryTaskPage,
    tasks,
    whatsNew,
};

const groupByLang = (translations) => {
    const accum = { ru: {}, en: {} };

    const traverse = (source, accum, prefix = '') => {
        for (const key in source) {
            if (isArray(source[key])) {
                accum.ru[prefix ? `${prefix}.${key}` : key] = source[key][0];
                accum.en[prefix ? `${prefix}.${key}` : key] = source[key][1];
            } else {
                traverse(source[key], accum, `${prefix ? `${prefix}.` : ''}${key}`);
            }
        }
    };

    traverse(translations, accum);

    return accum;
};

const translationsGropedByLang = groupByLang(translations);

export { translationsGropedByLang as translations };
